/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * Hier können Details des MoreControllers geändert werden. 
 * - Feedback - Text und E-Mail Adresse verwalten
 * - Tutorial - Text anpassen und Video-Anleitung hochladen
 * - Impressum - Text anpassen
 * 
 * Der Dialog kann nur durch einen Administrator gestartet werden.
 * 
 * Änderungen werden auf dem Server in der Datei 'settings.json' gespeichert.
 *  
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import FormControl from '@material-ui/core/FormControl';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { ModalTitle } from "../../partials/ModalTitle";
import FieldController from "../dialog/FieldController";

import * as appActions from "../../../store/actions/appActions";
import * as settingActions from "../../../store/actions/settingActions";

class MoreModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'MoreModal';

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog } = this.props.app;
        const { settingList } = this.props.setting;
        const { details } = this.props.app.modalDialog;

        if (details === null) return null;

        const onCancel = () => {
            this.props.closeModalDialog(); // appAction.js
        }

        const renderOkayButton = () => {
            const id = modalDialog.type.toLowerCase();

            const onOkay = () => {
                const newSystemSettings = settingList;

                if (id === 'feedback') {
                    const filter = modalDialog.details.fields.filter(f => f.id === 'email');
                    if (filter.length > 0) {
                        newSystemSettings['feedback'].email = filter[0].value;
                    }
                }

                const filter = modalDialog.details.fields.filter(f => f.id === id);

                if (filter.length > 0) {

                    newSystemSettings[id].text = filter[0].value;

                    this.props.updateSetting(id, newSystemSettings[id]);

                    this.props.closeModalDialog(); // appAction.js
                }
            }

            return (<Button onClick={onOkay} variant="contained" color="primary">OK</Button>)
        }

        const renderCancelButton = () => {

            const onCancel = () => {
                this.props.closeModalDialog(); // appAction.js
            }

            return (<Button onClick={onCancel} variant="outlined" color="default">Abbruch</Button>)
        }

        const renderDetails = () => {
            console.log('renderDetails() fields:', details.fields)

            const onChange = (id, value) => {

                if (this.debug) console.log('renderDetails:onChange id:' + id + ' value:' + value);

                var newDetails = {
                    ...details,
                    fields: details.fields.map(field => field.id !== id ? field : { ...field, value: value })
                }

                if (this.debug) console.log('renderDetails:onChange newDetails:', newDetails);

                this.props.setModalDialog(modalDialog.dialog, modalDialog.type, newDetails);
            }

            return (
                <div className="w-full">
                    <FormControl className="w-full">
                        {details.fields.map(field =>
                            <FieldController key={field.id}
                                disabled={false}
                                onChange={onChange}
                                {...field} />)}
                    </FormControl>
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        return (
            <div>
                <Dialog open={true} onClose={onCancel} fullWidth={true} maxWidth={'md'} >
                    <ModalTitle onClose={onCancel}>{details.title}</ModalTitle>
                    <DialogContent dividers>
                        {renderDetails()}
                    </DialogContent>
                    <DialogActions>
                        {renderCancelButton()}
                        <div className="flex-grow"></div>
                        {renderOkayButton()}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        setting: state.setting,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreModal);